import { defineComponent as _defineComponent } from 'vue'
import { useMediaAsset } from '~/composables';

interface Props {
  data?: { id?: string; items: any };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryInfoblocks',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

return { __sfc: true,getAssetUrl }
}

})